// extracted by mini-css-extract-plugin
module.exports = {"Container":"Home_Container__2zzhb","Heading":"Home_Heading__2kWWd","Board":"Home_Board__3BMbW","BoardContainer":"Home_BoardContainer__2-W1b"};